export default {
    nl: {
        intro: {
            subtitle: 'Pentest',
            title: 'Een veilig gevoel.',
            contact: 'Neem contact op',
            image: 'https://23g-website.s3.eu-central-1.amazonaws.com/services/pentest/hero.jpg',
        },
        type: 'Pentest',
        title: 'Pentest: Brede beveiligingsanalyse & risico minimalisatie',
        description:
            'Verhoog cybersecurity met onze pentest. We identificeren kwetsbaarheden, versterken je beveiliging en bouwen je digitale reputatie op.',
        content: [
            {
                type: 'text',
                title: 'Pentest',
                content: `
                In het digitale tijdperk van vandaag zijn beveiligings uitdagingen onvermijdelijk. Daarom wil je dat jouw digitale product grondig is getest, zodat problemen worden vermeden. Hier komt de pentest van pas. Bij een pentest duiken we diep in de software, op zoek naar kwetsbaarheden. Net als hackers of cybercriminelen, maar met een positief doel: het onthullen van verborgen risico's.
                <br><br>
                Met deze unieke benadering gaan we verder dan de oppervlakte en vinden we zwaktes in de beveiliging die vaak over het hoofd worden gezien. Zo bieden we niet alleen een krachtig inzicht, maar zetten we ook proactief stappen om de veiligheid te verbeteren en eventuele potentiële bedreigingen te verminderen.
                <br><br>
                Naast het directe onderzoek van de software, is het even belangrijk om andere technologische aspecten van een klantportaal, API of intranet te onderzoeken. Deze componenten vormen vaak een essentieel onderdeel van de digitale infrastructuur van een organisatie en verdienen evenveel aandacht op het gebied van beveiliging.
                `,
            },
            {
                type: 'text',
                title: 'Meer dan alleen codes kraken',
                content:
                    "Met een pentest investeer je direct in de digitale veiligheid van jouw organisatie. Hierbij gaat het niet alleen om de software zelf, maar ook om de bescherming van je medewerkers, klanten en je merkimago. Een snelle opsporing van potentiële datalekken of cyberaanvallen voorkomt veel schade. Zie het als een strategie voor je digitale veiligheid, waarin risico's worden geïdentificeerd en actieplannen worden opgesteld.",
            },
            {
                type: 'quote',
                content:
                    'Met een pentest investeer je direct in de digitale veiligheid van jouw organisatie.',
            },
            {
                type: 'text',
                title: 'Waarom een pentest essentieel is',
                content:
                    'Elke pentest biedt een uitgebreide evaluatie van de huidige beveiligingsstatus. Hiermee identificeren we kwetsbaarheden die misschien onopgemerkt zijn gebleven. Met deze inzichten ondernemen we actie, versterken we de digitale muren en maken we je organisatie nog robuuster maken tegen potentiële bedreigingen. Bovendien draagt een succesvolle pentest bij aan het vertrouwen en je reputatie van klanten en partners, wat je reputatie ten goede komt.',
            },
            {
                type: 'iso-certified',
                title: 'ISO 27001:2017',
                content: `
                    Niet zomaar een papiertje, maar dat betekent dat we bewezen kennis en kunde in huis hebben om onze informatiebeveiliging op orde te hebben. En dus ook die van onze klanten. <a href="/certificeringen/">ISO 27001:2017</a>, een internationaal erkende norm voor informatiebeveiliging, vormt de basis van onze toewijding aan veiligheid en vertrouwelijkheid.
                `,
            },
            {
                type: 'case',
                case: 'ferring',
            },
        ],
        related_services: ['back-end-development', 'api', 'front-end-development'],
        contact: {
            title: '',
            employee: 'jack',
        },
    },
    en: {},
};
